<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <parametros-upload
          ref="parametrosUpload"
          @validation-change="formValid = $event"
        />
      </v-col>

      <v-col cols="12">
        <v-btn
          id="btn-salvar-upload-log-unitizacao"
          color="green"
          min-width="140"
          style="float: right;"
          :disabled="!formValid"
          :loading="loading"
          @click="agendarUpload"
        >
          Agendar Unitização
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogUnitizacaoService from '@/services/LogUnitizacaoService';

export default {
  name: 'LogUnitizacaoUpload',

  components: {
    ParametrosUpload: () => import('@/components/logUnitizacao/ParametrosUpload.vue')
  },

  data() {
    return {
      formValid: false,
      loading: false
    };
  },

  methods: {
    agendarUpload() {
      this.loading = true;

      try {
        const data = this.$refs.parametrosUpload.exportData();

        LogUnitizacaoService.registrar(data)
          .then(() => {
            this.$router.push({ name: 'Log de Unitização Histórico', query: { tab: 'uploads' } });
            this.$toast.success('Unitização agendada com sucesso. Acompanhe o processamento no histórico.', '', { position: 'topRight' });
          })
          .catch((error) => {
            const msg = error?.response?.data?.erro || error?.data?.erro || 'Erro ao agendar unitização de Log de Unitização.';
            this.$toast.error(msg, '', { position: 'topRight' });
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.message || 'Erro ao validar dados da unitização.', '', { position: 'topRight' });
      }
    }
  }
};
</script>
